import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export default function HautVoixVerification() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [registrationId, setRegistrationId] = useState<string | null>(null);

  useEffect(() => {
    const id = searchParams.get("id");
    const token = searchParams.get("token");

    const verify = async () => {
      if (!id || !token) {
        setError("Paramètres manquants dans l'URL.");
        setIsVerifying(false);
        return;
      }

      try {
        const { data, error: rpcError } = await supabase.rpc(
          "verify_hav_registration_token",
          { registration_id: id, token } as any
        );
        if (rpcError) throw rpcError;

        const results = data as any[];
        if (!results || results.length === 0) {
          throw new Error("Lien de vérification invalide ou expiré.");
        }

        const result = results[0];
        if (["paid", "completed"].includes(result.payment_status)) {
          setError("Cette préinscription a déjà été réglée.");
          setIsVerifying(false);
          return;
        }

        await supabase.rpc("update_hav_registration_status", {
          registration_id: id,
          token,
          new_status: "pending_payment",
        } as any);

        setRegistrationId(id);
        setTimeout(() => navigate(`/hav-paiement?id=${id}`, { replace: true }), 1200);
      } catch (err: any) {
        setError(err.message || "Erreur de vérification");
      } finally {
        setIsVerifying(false);
      }
    };

    verify();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-[#FFF200] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <h1 className="text-3xl font-extrabold italic uppercase text-[#0A1A6B] text-center mb-6">
          À Haute Voix
        </h1>
        <div className="bg-white rounded-xl shadow-2xl p-6 text-center">
          <h2 className="text-xl font-bold text-[#0A1A6B] mb-4">
            Vérification de votre préinscription
          </h2>
          {isVerifying ? (
            <div className="flex flex-col items-center py-6">
              <Loader2 className="h-8 w-8 animate-spin text-[#0A1A6B] mb-3" />
              <p className="text-muted-foreground">Vérification en cours...</p>
            </div>
          ) : error ? (
            <>
              <p className="text-muted-foreground mb-4">{error}</p>
              <Button variant="outline" onClick={() => navigate("/inscription-AHV2026")}>
                Retour à l'inscription
              </Button>
            </>
          ) : (
            <>
              <p className="text-muted-foreground mb-4">Redirection vers le paiement...</p>
              <Button
                className="bg-[#0A1A6B] hover:bg-[#06124d] text-white"
                onClick={() => registrationId && navigate(`/hav-paiement?id=${registrationId}`)}
              >
                Procéder au paiement
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
